module.exports = __webpack_public_path__ + "static/media/LifeNome-logo-BETA.bbc1b915.svg";